import { usePrebookingResponse } from "../../data/PrebookingResponse";
import { Row, Col } from "react-grid-system";
import PricesCard from "./PricesCard";
import { usePrebookingRequest } from "../../data/PrebookingRequest";


function PreBookingInfoHorizontal() {
    const prebookingResponse = usePrebookingResponse(state => state.prebookingResponse);
    const loading = usePrebookingResponse(state => state.loading);
    const pass = usePrebookingRequest(state => state.prebooking?.pass ?? null);

    return (
        <Row gutterWidth={20} justify={"start"}>
            <Col style={{ marginBottom: "20px" }} md={12} lg={6} xl={6} xxl={4} >
                <PricesCard
                    name="You"
                    fullPriceWithoutQueueBeforeDiscount={prebookingResponse?.price.fullPriceWithoutQueueBeforeDiscount ?? 0}
                    fullPriceWithoutQueueAfterDiscount={prebookingResponse?.price.fullPriceWithoutQueueAfterDiscount ?? 0}
                    fullPriceWithQueueBeforeDiscount={prebookingResponse?.price.fullPriceWithQueueBeforeDiscount ?? 0}
                    fullPriceWithQueueAfterDiscount={prebookingResponse?.price.fullPriceWithQueueAfterDiscount ?? 0}
                    discounts={prebookingResponse?.price.discounts ?? []}
                    subevents={prebookingResponse?.subevents ?? []}
                    loading={loading}
                    pass={pass} />
            </Col>
            {
                prebookingResponse?.partners.map(x =>
                    <Col style={{ marginBottom: "20px" }} md={12} lg={6} xl={6} xxl={4}>
                        <PricesCard
                            key={x.id}
                            name={x.name + " " + x.surName}
                            fullPriceWithoutQueueBeforeDiscount={x.price.fullPriceWithoutQueueBeforeDiscount}
                            fullPriceWithoutQueueAfterDiscount={x.price.fullPriceWithoutQueueAfterDiscount}
                            fullPriceWithQueueBeforeDiscount={x.price.fullPriceWithQueueBeforeDiscount}
                            fullPriceWithQueueAfterDiscount={x.price.fullPriceWithQueueAfterDiscount}
                            discounts={x.price.discounts}
                            subevents={x.subevents}
                            loading={loading}
                            pass={pass}
                        />
                    </Col>)
            }
        </Row>
    );
}

export default PreBookingInfoHorizontal;